"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _AbstractButton = _interopRequireDefault(require("./AbstractButton"));
var _link = _interopRequireDefault(require("./link"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var _default = exports.default = (0, _AbstractButton.default)('PagerButton', (classes, props) => {
  if (props.disabled) {
    classes.push('disabled');
  }
  classes.push('btn-outline-primary');
  classes.push('btn-default');
  return /*#__PURE__*/_react.default.createElement(_link.default, {
    className: classes.join(' '),
    activeClassName: "active",
    to: props.to,
    exact: props.exact
  }, props.children);
});